import { Box, Card, Input } from '@coolblue-development/freddy';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
export const StyledInput = styled(Input) `
  width: 50%;

  span {
    width: auto;
  }
`;
const fadeIn = keyframes `
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;
export const StyledAlert = styled(Box) `
  animation: ${fadeIn} 0.3s ease-in-out 1 forwards;
  will-change: opacity;
`;
export const StyledCard = styled(Card) `
  ${({ selected }) => selected &&
    `
    border: 2px solid #0090e3;
    background-color: #f2f7fc;
    border-radius: 4px;
  `}
`;
//# sourceMappingURL=CustomComponents.js.map